import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { DbExercisesService } from 'src/services/db-exercises.service';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { ThemeService } from 'src/services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  isLoading: boolean = true;
  user$: Observable<any> | null = null;
  private backButtonSubscription!: Subscription;

  constructor(
    private auth: Auth,
    private router: Router,
    private location: Location,
    private dbExercises: DbExercisesService,
    private modalController: ModalController,
    private platform: Platform,
    private navCtrl: NavController,
    private themeService: ThemeService // needs to be here to initialize
  ) {}

  ngOnDestroy(): void {
    this.backButtonSubscription.unsubscribe();
  }

  ngOnInit() {
    this.user$ = authState(this.auth);
    this.user$.subscribe(async (user) => {
      const currentPath = this.location.path();

      this.dbExercises.fetchAndDecompressData();
      if (user && currentPath === '/home') {
        await this.router.navigate(['/start-workout']);
        this.isLoading = false;
      } else {
        this.isLoading = false;
      }
    });

    this.backButtonSubscription =
      this.platform.backButton.subscribeWithPriority(10, async () => {
        await this.closeAllModals();
        if (!(await this.modalController.getTop())) {
          this.navCtrl.pop();
        }
      });
  }

  @HostListener('window:popstate', ['$event'])
  async onPopState() {
    await this.closeAllModals();
  }

  private async closeAllModals() {
    let modal: HTMLIonModalElement | undefined;
    do {
      modal = await this.modalController.getTop();
      if (modal) {
        await modal.dismiss();
      }
    } while (modal);
  }
}
